export function buildMyIdOAuthStringACME(
    discoveryServiceURL: string,
    loginPageURL: string,
    returnTo?: string
): string {
    const genTokenURI = `${discoveryServiceURL}/auth/generateToken`;

    const paramsObj: { redirectUri: string; returnTo?: string } = {
        redirectUri: loginPageURL,
    };

    if (returnTo) {
        paramsObj.returnTo = encodeURIComponent(returnTo);
    }

    const params = new URLSearchParams(paramsObj);

    return `${genTokenURI}?${params.toString()}`;
}

window.location


const LAST_ATTEMPTED_REF_KEY = 'lastAttemptedHref'

export const setLastAttemptedRef = ($window: angular.IWindowService) => {
    if($window.location.hash !== '#/myidoptions') {
        sessionStorage.setItem(LAST_ATTEMPTED_REF_KEY, $window.location.href);
    }
}

export const getLastAttemptedRef = () => {
    return sessionStorage.getItem(LAST_ATTEMPTED_REF_KEY) || '/';
}

export const removeLastAttemptedRef = () => {
    sessionStorage.removeItem(LAST_ATTEMPTED_REF_KEY)
}
